/* Load the custom search/cart bundles only when they are about to be used. */
(function () {
  'use strict';

  var loader = document.currentScript;
  if (!loader) return;

  var urls = {
    search: loader.dataset.searchSrc,
    cart: loader.dataset.cartSrc,
    upsell: loader.dataset.upsellSrc,
  };
  var scripts = {};
  var searchPromise;
  var cartPromise;
  var searchReady = false;
  var cartReady = false;

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function loadScript(url) {
    if (!url) return Promise.resolve();
    if (scripts[url]) return scripts[url];

    scripts[url] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return scripts[url];
  }

  function loadSearch() {
    if (!searchPromise) {
      searchPromise = loadScript(urls.search).then(function () {
        searchReady = true;
      });
    }
    return searchPromise;
  }

  function loadCart() {
    if (!cartPromise) {
      cartPromise = Promise.all([loadScript(urls.cart), loadScript(urls.upsell)]).then(function () {
        cartReady = true;
      });
    }
    return cartPromise;
  }

  function warmInteraction(event) {
    if (closest(event.target, '.header__icon--search')) loadSearch().catch(function () {});
    if (closest(event.target, '#cart-icon-bubble')) loadCart().catch(function () {});
  }

  document.addEventListener('pointerover', warmInteraction, { passive: true, capture: true });
  document.addEventListener('focusin', warmInteraction, true);

  document.addEventListener('click', function (event) {
    var searchTrigger = closest(event.target, '.header__icon--search');
    if (searchTrigger && !searchReady) {
      event.preventDefault();
      event.stopImmediatePropagation();
      loadSearch()
        .then(function () { searchTrigger.click(); })
        .catch(function () {
          var details = searchTrigger.closest('details');
          if (details) details.setAttribute('open', '');
        });
      return;
    }

    var cartTrigger = closest(event.target, '#cart-icon-bubble');
    if (cartTrigger && !cartReady) {
      event.preventDefault();
      event.stopImmediatePropagation();
      loadCart()
        .then(function () { cartTrigger.click(); })
        .catch(function () { window.location.href = cartTrigger.href; });
    }
  }, true);

  // Start loading while an add-to-cart request is in flight.
  document.addEventListener('submit', function (event) {
    if (closest(event.target, 'product-form form')) loadCart().catch(function () {});
  }, true);

  // If an add-to-cart response beats the loader, replay its open event once ready.
  document.addEventListener('bp:cart:open', function (event) {
    if (cartReady) return;
    var detail = event.detail;
    event.stopImmediatePropagation();
    loadCart()
      .then(function () {
        document.dispatchEvent(new CustomEvent('bp:cart:open', { detail: detail }));
      })
      .catch(function () { window.location.href = window.routes.cart_url; });
  }, true);
}());
